"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _styles = _interopRequireDefault(require("./styles.scss"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Overlay
 * @param {Object} props The component properties
 */
var Overlay = function Overlay(props) {
  var _useState = (0, _react.useState)(props.defaultShowTooltip),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var className = _lodash.default.isEmpty(props.className) ? _styles.default['overlay-tooltip-action'] : props.className;
  var resizeTooltip = function resizeTooltip() {
    if (props.setSameAsParentWidth) {
      var tooltipParent = document.getElementById(props.parentId);
      var width = tooltipParent ? tooltipParent.offsetWidth : props.defaultWidth;
      return width;
    }
    return props.defaultWidth;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className,
    onMouseEnter: function onMouseEnter() {
      return setShow(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setShow(false);
    }
  }, props.children, show && /*#__PURE__*/_react.default.createElement("div", {
    style: _objectSpread(_objectSpread({}, props.position), {}, {
      width: resizeTooltip()
    }),
    className: "action-btn-tooltip"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip-content"
  }, props.text)));
};
Overlay.propTypes = {
  children: _propTypes.default.shape({}).isRequired,
  text: _propTypes.default.string,
  className: _propTypes.default.string,
  defaultShowTooltip: _propTypes.default.bool,
  setSameAsParentWidth: _propTypes.default.bool,
  parentId: _propTypes.default.string,
  position: _propTypes.default.shape({
    left: _propTypes.default.string,
    top: _propTypes.default.string
  }),
  defaultWidth: _propTypes.default.string
};
Overlay.defaultProps = {
  text: '',
  className: '',
  defaultShowTooltip: false,
  setSameAsParentWidth: false,
  parentId: '',
  position: {
    left: '',
    top: ''
  },
  defaultWidth: '100%'
};
var _default = Overlay;
exports.default = _default;